import React, { FC } from 'react'
import ReactMarkdown from 'react-markdown'
import { Text } from 'components/Text'
import { Heading, HeadingSizes } from 'components/Heading'
import styles from './Markdown.module.scss'

const MdHeading: FC<{ level: number }> = ({ level, ...rest }) => {
  const levels: { [key: number]: HeadingSizes } = {
    1: 'main',
    2: 'card',
    3: 'widget',
  }

  return <Heading size={levels[level || 4]} {...rest} />
}

const ListItem: FC = (props) => {
  return <Text component="li" {...props} />
}

type MarkdownProps = {
  source: string
}

export const Markdown: FC<MarkdownProps> = ({ source }) => {
  return (
    <div className={styles.markdown}>
      <ReactMarkdown
        source={source}
        renderers={{ paragraph: Text, heading: MdHeading, listItem: ListItem }}
      />
    </div>
  )
}

Markdown.displayName = 'markdown'
